import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import { TBiofouling2Place } from '../@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2A1Item1 = {
    durationAndDates: string;
};

export type TBFL2A1Item2 = {
    reasonForDeparture: string;
};
export type TBFL2A1Item3 = {
    contingencyActions: string;
};
export type TBFL2A1Item4 = {
    dateSMT: string;
    timeSMT: string;
    operationPlace: TBiofouling2Place;
};

export type TBFL2A1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2A1;
        item1: TBFL2A1Item1;
        item2: TBFL2A1Item2;
        item3: TBFL2A1Item3;
        item4: TBFL2A1Item4;
    };

export type TBFL2A = TBFL2A1;

const BFL2A_DEFAULTS: {
    A1: TBFL2A1;
} = {
    A1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            durationAndDates: '',
        },
        item2: {
            reasonForDeparture: '',
        },
        item3: {
            contingencyActions: '',
        },
        item4: {
            timeSMT: '',
            dateSMT: '',
            operationPlace: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        recordCode: EBFL2RecordCode.BFL2A1,
    },
};

export { BFL2A_DEFAULTS };
